<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 18H20V14H0V18ZM2 15H4V17H2V15ZM0 2V6H20V2H0ZM4 5H2V3H4V5ZM0 12H20V8H0V12ZM2 9H4V11H2V9Z"
              :fill="color" />
    </svg>
</template>
<script>
export default {
    name: "StorageIcon",
    props: {
        color: {
            type: String,
            default: "#3A3F48",
        },
    },
};
</script>
<style scoped>
</style>
